import React, { useState } from 'react'
import {
  Card,
  CardBody,
  CardExpandToggler,
  CardHeader
} from '../other/card/card'
import { Button } from 'antd'

const TaskDefinitionCard = ({ task }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const colorMap = {
    QUEUED: 'warning',
    STARTED: 'info',
    SUCCESS: 'success',
    FAILURE: 'danger'
  }

  const handleCardExpand = expanded => {
    setIsExpanded(expanded)
  }

  return (
    <Card>
      <CardHeader className='fw-bold small d-flex'>
        <span className='flex-grow-1'>{task?.task?.task_name}</span>
        <CardExpandToggler className='z-50' onExpandChange={handleCardExpand} />
      </CardHeader>
      <CardBody>
        <div className='flex gap-4'>
          <div className='flex flex-col'>
            <p className={`badge bg-${colorMap[task?.task.status]} h-4 max-w-20 ml-auto`}>
              {task?.task.status}
            </p>
            <p>
              Message: <br/>
              {task?.task?.message ? task?.task?.message : "Not Available"}
            </p>
            <p>
              Created At: <br />
              {formatDateTime(task?.task?.date_created)}
              <br />
              Done At: <br />
              {formatDateTime(task?.task?.date_done)}
            </p>

            {/* Always show download links */}
            <div className='mt-3 space-y-2'>
              {task?.task?.files?.original_file_url && (
                <>
                  <p className='fw-bold'>Download Files:</p>
                  <Button
                    type='link'
                    href={task.task.files.original_file_url}
                    target='_blank'
                  >
                    Download Original File
                  </Button>
                </>
              )}
              {task?.task?.files?.processed_file_url && (
                <Button
                  type='link'
                  href={task.task.files.processed_file_url}
                  target='_blank'
                >
                  Download Processed File
                </Button>
              )}
            </div>

            {/* Expand only shows raw result */}
            {isExpanded && (
              <div className='mt-3'>
                <p className='fw-bold'>Raw Result:</p>
                <pre className='text-xs bg-gray-100 p-2 rounded'>
                  {task?.task?.result}
                </pre>
              </div>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default TaskDefinitionCard

function formatDateTime (isoString) {
  if (!isoString) return '-'
  const date = new Date(isoString)

  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')

  return `${day}-${month}-${year} ${hours}:${minutes}`
}
